module.exports = __webpack_public_path__ + "static/don24-bd5fee324bb4fd8cc7d53cb0dacd1e50.jpg";